class SodProductCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.sod-collection__track');
    this.items = Array.from(this.querySelectorAll('.sod-collection__item:not(.sod-collection__item--filler)'));
    this.fillers = Array.from(this.querySelectorAll('.sod-collection__item--filler'));
    this.arrows = Array.from(this.querySelectorAll('[data-scroll]'));
    this.pills = Array.from(this.querySelectorAll('[data-filter]'));

    this.active = Math.max(
      this.pills.findIndex((pill) => pill.getAttribute('aria-pressed') === 'true'),
      0
    );

    if (!this.track) return;

    this.arrows.forEach((a) => a.addEventListener('click', this.onArrow));
    this.pills.forEach((p) => p.addEventListener('click', this.onPill));

    this.track.addEventListener('scroll', this.syncArrows, { passive: true });
    this.desktop = window.matchMedia('(min-width: 750px)');
    this.desktop.addEventListener('change', this.applyMobileLimit);
    this.syncArrows();
    this.applyMobileLimit();

    this.items.forEach((item) => {
      const video = item.querySelector('video.sod-card__hover');
      if (!video) return;
      const card = item.querySelector('.sod-card');
      card?.addEventListener('pointerenter', () => video.play().catch(() => {}));
      card?.addEventListener('pointerleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  disconnectedCallback() {
    this.arrows.forEach((a) => a.removeEventListener('click', this.onArrow));
    this.pills.forEach((p) => p.removeEventListener('click', this.onPill));
    this.track?.removeEventListener('scroll', this.syncArrows);
    this.desktop?.removeEventListener('change', this.applyMobileLimit);
  }

  onArrow = (event) => {
    const direction = Number(event.currentTarget.dataset.scroll) || 1;
    const step = this.items[0]?.getBoundingClientRect().width || this.track.clientWidth;
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  };

  syncArrows = () => {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const max = scrollWidth - clientWidth - 1;
    this.arrows.forEach((a) => {
      const forward = Number(a.dataset.scroll) > 0;
      a.toggleAttribute('disabled', forward ? scrollLeft >= max : scrollLeft <= 0);
    });
  };

  applyMobileLimit = () => {
    const limit = Number(this.dataset.mobileLimit) || 0;
    const narrow = !this.desktop.matches;

    const placed = [];

    for (const item of this.items) {
      const eligible =
        narrow &&
        !item.classList.contains('is-filtered-out') &&
        !item.classList.contains('sod-collection__item--desktop-only');
      const over = eligible && limit > 0 && placed.length >= limit;
      if (eligible && !over) placed.push(item);
      item.classList.toggle('is-over-limit', over);
    }

    const odd = placed.length % 2 === 1;
    for (const filler of this.fillers) {
      const wanted = odd && Number(filler.dataset.filler) === this.active;
      filler.classList.toggle('is-shown', wanted);
      if (wanted) placed.push(filler);
    }

    this.placeCells(narrow ? placed : []);
  };

  placeCells = (placed) => {
    for (const cell of [...this.items, ...this.fillers]) {
      const at = placed.indexOf(cell);
      cell.classList.toggle('is-col-a', at > -1 && at % 2 === 0);
      cell.classList.toggle('is-col-b', at > -1 && at % 2 === 1);
      cell.classList.toggle('is-row-a', at > -1 && at < 2);
      cell.classList.toggle('is-row-b', at > 1);
    }
  };

  onPill = (event) => {
    const pill = event.currentTarget;
    const handle = pill.dataset.filter;

    this.active = this.pills.indexOf(pill);
    this.pills.forEach((p) => p.setAttribute('aria-pressed', String(p === pill)));

    this.items.forEach((item) => {
      const handles = (item.dataset.collections || '').split(/\s+/);
      const show = !handle || handle === 'all' || handles.includes(handle);
      item.classList.toggle('is-filtered-out', !show);
    });

    this.applyMobileLimit();
    this.syncArrows();
  };
}

if (!customElements.get('sod-product-carousel')) {
  customElements.define('sod-product-carousel', SodProductCarousel);
}
